import { useState, useEffect } from 'react';
import { differenceInMinutes } from 'date-fns';

export const useRelativeTime = (isoString?: string): string => {
  const [relativeTime, setRelativeTime] = useState('');

  useEffect(() => {
    if (!isoString) {
      setRelativeTime('');
      return;
    }

    const updateRelativeTime = () => {
      try {
        const date = new Date(isoString);
        const now = new Date();

        const diffMinutes = differenceInMinutes(now, date);

        if (diffMinutes < 1) {
          setRelativeTime("À l'instant");
        } else if (diffMinutes < 60) {
          setRelativeTime(`Il y a ${diffMinutes} min`);
        } else {
          const diffHours = Math.floor(diffMinutes / 60);
          if (diffHours < 24) {
            setRelativeTime(`Il y a ${diffHours}h`);
          } else {
            setRelativeTime(date.toLocaleDateString('fr-CA'));
          }
        }
      } catch (error) {
        console.error('Error formatting relative time:', error);
        setRelativeTime('');
      }
    };

    updateRelativeTime();

    const interval = setInterval(updateRelativeTime, 10000);

    return () => clearInterval(interval);
  }, [isoString]);

  return relativeTime;
};